var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.53846 2.38462C2.90121 2.38462 2.38462 2.90121 2.38462 3.53846V16.4615C2.38462 17.0102 2.76749 17.4693 3.28062 17.5865L13.2028 7.6643C13.4732 7.39393 13.9115 7.39393 14.1819 7.6643L17.6154 11.0978V3.53846C17.6154 2.90121 17.0988 2.38462 16.4615 2.38462H3.53846ZM19 12.7645V3.53846C19 2.13651 17.8635 1 16.4615 1H3.53846C2.13651 1 1 2.13651 1 3.53846V16.4615C1 17.8635 2.13651 19 3.53846 19H16.4615C17.8635 19 19 17.8635 19 16.4615V12.7739C19 12.7708 19 12.7676 19 12.7645ZM17.6154 13.056L13.6923 9.1329L5.20984 17.6154H16.4615C17.0988 17.6154 17.6154 17.0988 17.6154 16.4615V13.056ZM6.76922 6.07691C6.38686 6.07691 6.07691 6.38686 6.07691 6.76922C6.07691 7.15157 6.38686 7.46152 6.76922 7.46152C7.15157 7.46152 7.46152 7.15157 7.46152 6.76922C7.46152 6.38686 7.15157 6.07691 6.76922 6.07691ZM4.69229 6.76922C4.69229 5.62216 5.62216 4.69229 6.76922 4.69229C7.91627 4.69229 8.84614 5.62216 8.84614 6.76922C8.84614 7.91627 7.91627 8.84614 6.76922 8.84614C5.62216 8.84614 4.69229 7.91627 4.69229 6.76922Z",
  fill: "white"
});

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.202583e9.svg";
export { ForwardRef as ReactComponent };